import { render } from "./ContentTextBlock.vue?vue&type=template&id=111df8e8&scoped=true"
import script from "./ContentTextBlock.vue?vue&type=script&lang=js"
export * from "./ContentTextBlock.vue?vue&type=script&lang=js"

import "./ContentTextBlock.vue?vue&type=style&index=0&id=111df8e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111df8e8"]])

export default __exports__